import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: center;
  }
`;

export const Bg = styled.div`
  height: 400px;
  width: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--aluminium20);
  border-radius: 12px 0 0 12px;
  flex-shrink: 0;

  @media (max-width: 1023px) {
    flex-shrink: 1;
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 220px;
    background: none;
  }
`;

export const List = styled.div`
  padding: 60px 40px;

  @media (max-width: 767px) {
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 334px;
    margin: 0 auto;
    padding: 7px 30px 30px;
  }

  @media (max-width: 500px) {
    max-width: none;
  }
`;

export const Title = styled.div`
  font-size: 20px;
  color: var(--carbone100);
  margin: 25px 0;
  max-width: 80%;

  strong {
    font-size: 20px;
    font-weight: 600;
  }

  @media (max-width: 767px) {
    margin-top: 0;
    max-width: none;
  }
`;

export const ControlWrap = styled.div`
  width: 270px;
  margin-bottom: 24px;

  @media (max-width: 767px) {
    width: 260px;
  }
`;

export const ResetCity = styled.div`
  cursor: pointer;
  color: var(--theme-palette-buttons-secondary-color);

  &:hover {
    color: var(--theme-palette-buttons-secondary-color-hover);
  }
`;
